import {Injectable} from '@angular/core';
import {Calendar} from "@ionic-native/calendar";
import {GlobalProvider} from "../global/global";

/*
  Generated class for the CalendarProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CalendarProvider {

  constructor(public calendar: Calendar, private globalProvider: GlobalProvider) {
    console.log('Hello CalendarProvider Provider');
  }

  public insertEventInNativeCalendar(customer: any, startDate: number): void {
    this.calendar.createEvent(customer.company, null, null, new Date(startDate));

  }

  public createCalendarIfNotExists(): void {

    this.calendar.requestReadWritePermission()
      .then(() => {
        this.calendar.listCalendars()
          .then((calendars) => {
            return new Promise((resolve, reject) => {
              for(let cal of calendars){
                if(cal.name === this.globalProvider.calendarName){
                  resolve(cal);
                }
              }
              reject();
            })
          })
          .catch(() => {
            //calendar not in device -> create Calendar
            this.calendar.createCalendar(this.globalProvider.calendarName);
          })
      })

  }

}



// WEBPACK FOOTER //
// ./src/providers/calendar/calendar.ts